import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { WorkCentersView } from "src/components/views/erp/production/masterData/workcenter/workCentersView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/production/workCenters")({
	staticData: { title: i18n.t("work_centers"), legacyViewKey: "workCentersView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <WorkCentersView />;
}
